import HttpRequest from './http_request'
import { getStoreBearer } from '@/utils/helper/localStorage'

class OrderProvider extends HttpRequest {
  constructor () {
    super(process.env.SELLSUKI_URL)
  }
  async posCompleteCart (params) {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const { data: { results } } = await this.create('/bill/poscompletecart', params.data)
    return results
  }
}

export default OrderProvider



// WEBPACK FOOTER //
// ./src/resources/order_provider.js